<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "registry_templates",
    cardSetLink: "registry_templates",
    item: null,
    fields: [
      // $table->string('name'); //uzum
      //         $table->string('header_external'); //id
      //         $table->string('header_internal'); //UZUM id
      //         $table->string('code'); //uzum
      {
        col: " col-12 col-md-6",
        key: "name",
        label: "Название",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "header_external",
        label: "Название шапки EXCEL (внешний)",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "header_internal",
        label: "Название шапки EXCEL (внутренний)",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "code",
        label: "Код",
        type: "field",
        textType: "text",
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>
<style>
</style>
